/* eslint-disable camelcase */

import { Dayjs } from 'dayjs';

export interface ICardProduct {
  id: string,
  name: string,
  bin: string,
  range: string,
  brand: string,
  product_type: string,
  start_date: string,
  end_date: string,
  active: boolean,
}
export interface ICardProductUpdate {
  id?: string,
  name?: string,
  bin?: string,
  range?: string,
  design?: string,
  start_date?: string,
  end_date?: string,
  brand?: string,
  max_risk_visa?: number,
  active?: boolean,
  product_type?: string,
  life_cycle?: number,
  recording_code?: number,
  logo?: string,
  card_affinity_group_id?: number
}
export interface ITaxes {
  name: string,
  value: number,
  exceptions: []
}
export interface ICharges {
  type: string,
  value: number,
  taxes: ITaxes[]
}

export interface IFees {
  origin: string,
  allowed: boolean,
  fixed_fee: number,
  fee: number,
  tax_fee: number
}

export interface ILimits {
  min_amount: number,
  max_amount: number,
  max_daily_amount: number,
  source_exclusions: string[]
}
export interface ICardProductFull {
  id: string,
  name: string,
  bin: string,
  range: string,
  brand: string,
  product_type: string,
  start_date: string,
  end_date: string,
  active: boolean,
  charges: ICharges[],
  life_cycle: number,
  design: string,
  fees: IFees[],
  transaction_limits: {
    load: ILimits,
    purchase: ILimits,
    cash_out: ILimits
  },
  logo: string,
  commercial_bin: boolean,
  recording_code: number
}

export interface ICardProducts {
  pagination: {
    page: number;
    total: number;
    size: number;
  };
  data: ICardProductFull[];
}

export type ICardConfigurations = {
  virtual: IConfigurationDTO,
  physical: IConfigurationDTO,
  exp_date: IConfigurationDTO,
  cvv: IConfigurationDTO,
}

export type IConfigurationDTO = {
  allowed: boolean;
}
export type ICashback = {
  min_amount: number;
  max_amount: number;
}

export type CreateCardProduct = {
  name: string;
  bin: string;
  institution_id?: string;
  range?: string;
  brand?: string
  active?: boolean;
  start_date?: string;
  end_date?: string;
  card_configurations: ICardConfigurations;
  cashback?: ICashback;
  life_cycle: number;
  design: string;
  logo?: string;
  commercial_bin?: boolean;
  recording_code: number;
  product_type: string;
  card_affinity_group_id: string;
}


export const ProductType = [
  { label: 'Mastercard_Prepaid_Recargable', value: 'MP1002' },
  { label: 'Mastercard_Prepaid_Commercial', value: 'MP1011' },
  { label: 'VISA_Prepaid_Recargable', value: 'DB1002' },
  { label: 'VISA_Prepaid_Regalo', value: 'DB2001' },
];

export const CardProductType = [
  { label: 'NACIONAL', value: 'NACIONAL' },
  { label: 'INTERNACIONAL', value: 'INTERNACIONAL' },
  { label: 'GOLD', value: 'GOLD' },
  { label: 'BUSINESS', value: 'BUSINESS' },
  { label: 'PURCHASING', value: 'PURCHASING' },
  { label: 'PRACTICA', value: 'PRACTICA' },
  { label: 'COPORATE_GRIS', value: 'COPORATE_GRIS' },
  { label: 'CORPORATE_ORO', value: 'CORPORATE_ORO' },
  { label: 'PLATINUM', value: 'PLATINUM' },
  { label: 'ELECTRON', value: 'ELECTRON' },
  { label: 'E_CARD', value: 'E_CARD' },
  { label: 'PLATINUM_GRIS', value: 'PLATINUM_GRIS' },
  { label: 'AGRO', value: 'AGRO' },
  { label: 'PURCHASING_INTERNACIONAL', value: 'PURCHASING_INTERNACIONAL' },
  { label: 'BUSSINESS_COMERCIOS', value: 'BUSSINESS_COMERCIOS' },
  { label: 'MINICARD', value: 'MINICARD' },
  { label: 'CUENTA_CENTRAL', value: 'CUENTA_CENTRAL' },
  { label: 'AGRO_CLASIC', value: 'AGRO_CLASIC' },
  { label: 'AGRO_PURCHASING_INTERNACIONAL', value: 'AGRO_PURCHASING_INTERNACIONAL' },
  { label: 'DISTRIBUTION', value: 'DISTRIBUTION' },
  { label: 'SIGNATURE', value: 'SIGNATURE' },
  { label: 'HONOR', value: 'HONOR' },
  { label: 'MONEDERO_TAG', value: 'MONEDERO_TAG' },
  { label: 'MONEDERO_BILLETERA', value: 'MONEDERO_BILLETERA' },
  { label: 'MONEDERO_EMPRESA_TAG', value: 'MONEDERO_EMPRESA_TAG' },
  { label: 'MONEDERO_EMPRESA_BILLETERA', value: 'MONEDERO_EMPRESA_BILLETERA' },
  { label: 'EMV_CONTACTO', value: 'EMV_CONTACTO' },
  { label: 'EMV_DUAL', value: 'EMV_DUAL' },
  { label: 'REGALO_WISH', value: 'REGALO_WISH' },
  { label: 'EMV_CORPORATE_GRIS_CONTACTO', value: 'EMV_CORPORATE_GRIS_CONTACTO' },
  { label: 'EMV_CORPORATE_GRIS_DUAL', value: 'EMV_CORPORATE_GRIS_DUAL' },
  { label: 'EMV_CORPORATE_GOLD_CONTACTO', value: 'EMV_CORPORATE_GOLD_CONTACTO' },
  { label: 'EMV_CORPORATE_GOLD_DUAL', value: 'EMV_CORPORATE_GOLD_DUAL' }
];

export const visaDesigns = [
  {
    label: 'A01',
    value: 'A01',
  },
  {
    label: 'A02',
    value: 'A02',
  },
  {
    label: 'A03',
    value: 'A03',
  },
  {
    label: 'A04',
    value: 'A04',
  },
  {
    label: 'Q01',
    value: 'Q01',
  },
  {
    label: 'Q03',
    value: 'Q03',
  },
  {
    label: 'Q05',
    value: 'Q05',
  },
  {
    label: 'Q07',
    value: 'Q07',
  },
  {
    label: 'Q09',
    value: 'Q09',
  },
  {
    label: 'Q10',
    value: 'Q10',
  },
  {
    label: 'Q13',
    value: 'Q13',
  },
  {
    label: 'Q16',
    value: 'Q16',
  },
  {
    label: 'Q18',
    value: 'Q18',
  },
  {
    label: 'Q19',
    value: 'Q19',
  },
  {
    label: 'Q20',
    value: 'Q20',
  },
  {
    label: 'Q23',
    value: 'Q23',
  },
  {
    label: 'T01',
    value: 'T01',
  },
  {
    label: 'T04',
    value: 'T04',
  }
];

export const mastercardDesigns = [
  {
    label: 'M01',
    value: 'M01',
  },
  {
    label: 'M02',
    value: 'M02',
  },
  {
    label: 'M03',
    value: 'M03',
  },
  {
    label: 'M04',
    value: 'M04',
  },
  {
    label: 'M05',
    value: 'M05',
  },
  {
    label: 'M06',
    value: 'M06',
  },
  {
    label: 'M07',
    value: 'M07',
  },
  {
    label: 'M08',
    value: 'M08',
  },
  {
    label: 'M09',
    value: 'M09',
  }
]
 
export const productType = [
	{
		label: 'PREPAID',
		value: 'PREPAID'
	},{
		label: 'GIFT CARD',
		value: 'GIFT_CARD'
	}
]
